import React, { FC } from 'react';
import { Tab, useTranslate, usePermissions } from 'react-admin';
import { PaperTabbedShowLayout, Show, RecordTitle } from '~/layout';
import { NoPermissions } from '~/components/ra';
import Details from './components/Details';
import { Transfer } from '~/types/Transfer';
import { amountToString } from '~/utils/amountFormat';
import { hasTranslation } from '~/utils';
import Aside from './components/Aside';

export const i18nPath = 'resources.transfers.';

const label = (key: string): string => `resources.transfers.show.${key}`;
export const tcLabel = (key: string) => `${i18nPath}transferCategories.${key}`;

const TransfersShow: FC<any> = (implicitProps) => {
  const { permissions } = usePermissions();
  const translate = useTranslate();
  const t = (key: string): string => translate(label(key));
  if (!permissions) return null;
  if (!permissions.includes('transaction.transfers.view')) return <NoPermissions />;

  return (
    <Show
      {...implicitProps}
      actions={null}
      title={<RecordTitle headline={(record: Transfer) => <Header record={record} />} />}
    >
      <PaperTabbedShowLayout>
        <Tab label={t('tabs.details')}>
          <Details record={implicitProps.record} />
        </Tab>
      </PaperTabbedShowLayout>
      <Aside />
    </Show>
  );
};

const Header: FC<{ record: Transfer }> = (props) => {
  const { record } = props;
  const translate = useTranslate();
  const t = (key: string): string => translate(label(key));
  const amount = record?.details?.baseAmount || record?.amount;
  const amountText = amountToString(amount);
  const operationType = translate(`operationType.${record?.transferOperationType}`);
  const category =
    record?.transferCategory && hasTranslation(tcLabel(record?.transferCategory))
      ? translate(tcLabel(record?.transferCategory))
      : record?.transferCategory;
  return <>{`${category ? category : ''} ${operationType ?? t('transferHeader')} ${amountText}`}</>;
};

export default TransfersShow;
